import React, { Component } from 'react';
import fire from '../fire';
import classnames from 'classnames';
import './GameListItem.css';
import { Progress } from 'reactstrap';
import {Icon} from 'react-fa'
import TeamIcon from "./TeamIcon";

class GameListItem extends Component {

    constructor(props) {
        super(props);
        this.state = {vote: 0, user: {}};
        this.bindVote();
        this.getVotes();
    }
    getVotes() {
        let votesRef = fire.database().ref('v1/betting/votes/' + this.props.game.GameCode).orderByValue();
        votesRef.equalTo(-1).on('value', function(snapshot) {
            this.setState({'numberOfHomeVotes': snapshot.numChildren()});
        }.bind(this));
        votesRef.equalTo(1).on('value', function(snapshot) {
            this.setState({'numberOfGuestVotes': snapshot.numChildren()});
        }.bind(this));
    }
    vote(team) {
        let votesRef = fire.database().ref('v1/betting/votes/' + this.props.game.GameCode);
        votesRef.update({ [this.props.user.uid]: team})
    }

    bindVote() {
        let votesRef = fire.database().ref('v1/betting/votes/' + this.props.game.GameCode + '/' + this.props.user.uid);
        votesRef.on('value', snapshot => {
            this.setState({vote: snapshot.val()});
        });
    }
    setProgressValue() {
        if (this.state.numberOfHomeVotes >= this.state.numberOfGuestVotes) {
            this.setState({value: this.state.numberOfHomeVotes });
        } else {
            this.setState({value: this.state.numberOfGuestVotes });
        }
    }

    render() {
        let classes = classnames({
            'game-list-item': true,
        });
        let resultClasses = classnames({
            'result': true,
            'right': this.state.numberOfGuestVotes > this.state.numberOfHomeVotes,
            'vote-home': this.state.vote === -1,
            'vote-guest': this.state.vote === 1,
            'vote-none': this.state.vote === null
        });
        let homeClasses = classnames({
            'voted': this.state.vote === -1
        });
        let guestClasses = classnames({
            'voted': this.state.vote === 1
        });

        return (
            <div className={classes}>
                <div className="team" onClick={() => {this.vote(-1)}}>
                    <TeamIcon teamId={this.props.game.HomeTeamCode} teamName={this.props.game.HomeTeamName}  />
                </div>
                <div className={resultClasses}>
                    <div className="vote-row">
                        <div><Icon onClick={() => {this.vote(-1)}} name="thumbs-o-up" className={homeClasses}/> {this.state.numberOfHomeVotes}</div>
                        <div>{this.state.numberOfGuestVotes} <Icon onClick={() => {this.vote(1)}} flip="horizontal" name="thumbs-o-up" className={guestClasses}/></div>
                    </div>
                    <Progress value={(this.state.numberOfHomeVotes + this.state.numberOfGuestVotes) > 0 ? this.state.numberOfHomeVotes : 50} max={(this.state.numberOfHomeVotes + this.state.numberOfGuestVotes) > 0 ? (this.state.numberOfHomeVotes + this.state.numberOfGuestVotes) : 100} />
                </div>
                <div className="team" onClick={() => {this.vote(1)}}>
                    <TeamIcon teamId={this.props.game.GuestTeamCode} teamName={this.props.game.GuestTeamName}/>
                </div>
            </div>
        );
    }
}

export default GameListItem;


// WEBPACK FOOTER //
// ./src/GameList/GameListItem.js